export const ErrorIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="34" height="34" viewBox="0 0 34 34" fill="none">
    <path
      d="M17.0002 33.6667C7.79541 33.6667 0.333496 26.2047 0.333496 17C0.333496 7.79524 7.79541 0.333328 17.0002 0.333328C26.2048 0.333328 33.6668 7.79524 33.6668 17C33.6668 26.2047 26.2048 33.6667 17.0002 33.6667ZM17.0002 14.643L12.2861 9.92893L9.9291 12.2859L14.6432 17L9.9291 21.714L12.2861 24.071L17.0002 19.357L21.7142 24.071L24.0712 21.714L19.3572 17L24.0712 12.2859L21.7142 9.92893L17.0002 14.643Z"
      fill="#BE123C"
    />
  </svg>
);
